import React, { useMemo } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import type { PatientSchema } from '@/zod_schemas';
import { PatientContext } from '../PatientContext';
import { PatientMode } from '../types/types';

type PatientProviderProps = {
  mode: PatientMode;
  patientId?: string;
  form: UseFormReturn<PatientSchema>;
  children: React.ReactNode;
};

export const PatientProvider: React.FC<PatientProviderProps> = ({
  mode,
  patientId,
  form,
  children,
}) => {
  const value = useMemo(
    () => ({ mode, patientId, form }),
    [mode, patientId, form],
  );

  return (
    <PatientContext.Provider value={value}>{children}</PatientContext.Provider>
  );
};
